// extracted by mini-css-extract-plugin
export default {"input":"CounterCash_input__3BevM"};